import React from "react";
import "../modal-base.css";

export default function ConfirmationModal({ message, handleConfirm, onClose }) {
    return (
        <div className="modal-backdrop">
            <div className="modal-box">
                <button className="modal-close" onClick={onClose}>×</button>
                <div style={{ overflow: 'auto', height: '100%', padding: '20px' }}>
                    <h2 style={{ marginBottom: '40px' }}>{message}</h2>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                        <button className="btn filled" onClick={handleConfirm}>تأكيد</button>
                        <button className="btn outline" onClick={onClose}>إلغاء</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
